<template>
  <div class="b-pagination" v-if="totalRecord">
    <div class="b-pagination-item" :class="currentPage === 1 || totalRecord === 0 ? 'cursor-not-allowed' : ''">
      <span @click="gotoFirstPage" :class="[currentPage === 1 || totalRecord === 0 ? 'pointer-events-none color-gray' : '']" class="icon icon-bor-arrow-p-l"></span>
    </div>
    <a-pagination
      v-model="currentPage"
      :page-size="pageSize"
      :total="totalRecord"
      @change="handleChange"
      :show-less-items="showLessItems"
    >
    </a-pagination>
    <div class="b-pagination-item" :class="currentPage === Math.ceil(totalRecord / pageSize) || totalRecord === 0 ? 'cursor-not-allowed' : ''">
      <span @click="gotoLastPage" :class="currentPage === Math.ceil(totalRecord / pageSize) || totalRecord === 0 ? 'pointer-events-none color-gray' : ''" class="icon icon-bor-arrow-p-r"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    page: {
      default: 1
    },
    totalRecord: {
      type: Number,
      default: 0
    },
    pageCount: {
      type: Number,
      default: 0
    },
    pageSlot: {
      type: Number,
      default: 5
    },
    showLessItems: {
      type: Boolean,
      default: false
    },
    /**
     * ページ上部へ遷移するフラグ
     * スクロール処理は画面毎に指定
     * @see {@link src/views/menu/PlanList/index.vue } paging関数参照
     */
    isScrollTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.currentPage = this.page
  },
  watch: {
    page(val) {
      this.currentPage = +val
    }
  },
  methods: {
    gotoFirstPage() {
      this.currentPage = 1
      this.$emit('onChange', this.currentPage, this.isScrollTop)
    },
    gotoLastPage() {
      this.currentPage = Math.ceil(this.totalRecord / this.pageSize)
      this.$emit('onChange', this.currentPage, this.isScrollTop)
    },
    handleChange($event) {
      this.$emit('onChange', $event, this.isScrollTop)
    }
  }
}
</script>
<style scoped lang="scss">
@import "./style.scss";
::v-deep .ant-pagination-item {
  border: none !important;
  background-color: transparent !important;
  color: #a8aaad;
  &--active {
    font-weight: 600;
    color: #1f2021 !important;
  }
  @media only screen and (max-width: 768px){
    margin-right: 0px;
  }
}
::v-deep .ant-pagination-item.ant-pagination-item-active a {
  font-weight: 700;
  color: #1f2021 !important;
}
::v-deep .ant-pagination-prev .ant-pagination-item-link {
  @apply flex items-center justify-center;
  border: none !important;
}
::v-deep .ant-pagination-next .ant-pagination-item-link {
  @apply flex items-center justify-center;
  border: none !important;
}
</style>
